import { ReactNode, useState } from "react";
import SocialLoginButtons from "./SocialLoginButtons";
import EmailLinkForm from "./EmailLinkForm";
import { ModalWithIcon } from "@components/RfModal/ModalWithIcon";
import { useAnalytics } from "@/contexts/AnalyticsContext";
import { AnalyticsAuthenticationEvent } from "@/analytics/types";
import { noop } from "lodash";

interface LoginComponentProps {
    isOpen?: boolean;
    onClose?: () => void;
    onSuccess?: () => void;
    redirectPath?: string;
    title?: string | ReactNode;
    showSeparator?: boolean;
}

export default function LoginComponent({
    isOpen = true,
    onClose = noop,
    onSuccess,
    redirectPath = "/need-auth",
    title = "Sign In or Create An Account",
    showSeparator = true
}: LoginComponentProps) {
    const [hasSentLink, setHasSentLink] = useState(false);
    const { track } = useAnalytics();

    const handleSuccess = (u: any) => {
        if (onSuccess) {
            onSuccess();
        }

        track({
            event: AnalyticsAuthenticationEvent.USER_SIGNED_IN,
            data: { email: u.email, method: u.providerData[0]?.providerId, name: u.displayName }
        });
    };

    return (
        <ModalWithIcon
            isOpen={isOpen}
            onClose={onClose}
            icon={hasSentLink ? "fad fa-envelope" : "fad fa-user"}
            title={hasSentLink ? "We emailed you a link to log in" : title}
            size="sm"
            showFooter={false}
            className="gap-6"
            panelClassName="gap-6"
        >
            {/* Email link form */}
            <EmailLinkForm hasSentLink={hasSentLink} setHasSentLink={setHasSentLink} />

            {!hasSentLink && (
                <>
                    {/* Separator */}
                    {showSeparator && (
                        <div className="flex items-center gap-4">
                            <div className="flex-grow border-t border-divider"></div>
                            <span className="flex-shrink-0 text-xs text-tertiary">OR</span>
                            <div className="flex-grow border-t border-divider"></div>
                        </div>
                    )}
                    {/* Social logins */}
                    <SocialLoginButtons onSuccess={handleSuccess} redirectPath={redirectPath} />
                </>
            )}
        </ModalWithIcon>

        // <div className={twClassNames("flex w-full flex-col gap-6", className)}>
        //     {/* Header */}
        //     {(showTitle || showSubtitle) && (
        //         <div className="mb-6 text-center">
        //             {showTitle && (
        //                 <h2
        //                     className={twClassNames(
        //                         "text-2xl font-bold text-gray-900",
        //                         titleClassName
        //                     )}
        //                 >
        //                     {title}
        //                 </h2>
        //             )}
        //             {showSubtitle && (
        //                 <p
        //                     className={twClassNames(
        //                         "mt-2 text-sm text-gray-600",
        //                         subtitleClassName
        //                     )}
        //                 >
        //                     {subtitle}
        //                 </p>
        //             )}
        //         </div>
        //     )}

        //     {/* Error Display */}
        //     {error && (
        //         <InlineAlert level="danger">
        //             <p className="font-medium">Error</p>
        //             <p>{error}</p>
        //         </InlineAlert>
        //     )}

        //     {/* Email link form */}
        //     <EmailLinkForm onSuccess={handleSuccess} />

        //     {/* Separator */}
        //     {showSeparator && (
        //         <div className="flex items-center gap-4">
        //             <div className="flex-grow border-t border-divider"></div>
        //             <span className="flex-shrink-0 text-xs text-tertiary">OR</span>
        //             <div className="flex-grow border-t border-divider"></div>
        //         </div>
        //     )}

        //     {/* Social logins */}
        //     <SocialLoginButtons onSuccess={handleSuccess} redirectPath={redirectPath} />
        // </div>
    );
}
